import React from 'react';
import { Box, Container, Grid, Paper, Link } from '@mui/material';
import Typo from './Typo';
import { useTranslation } from 'react-i18next';

const Advantages = () => {
  const { t } = useTranslation();

  const items = [
    {
      icon: '/assets/chekup/Intro1.png',
      title: t('advantages1Title'),
      description: t('advantages1Description'),
      link: t('advantages1Link'),
      linkUrl: '/meet-chekup',
    },
    {
      icon: '/assets/chekup/Intro2.png',
      title: t('advantages2Title'),
      description: t('advantages2Description'),
      link: t('advantages2Link'),
      linkUrl: '/meet-chekup',
    },
    {
      icon: '/assets/chekup/Intro3.png',
      title: t('advantages3Title'),
      description: t('advantages3Description'),
      link: t('advantages3Link'),
      linkUrl: '/meet-chekup',
    },
    {
      icon: '/assets/chekup/Intro4.png',
      title: t('advantages4Title'),
      description: t('advantages4Description'),
      link: t('advantages4Link'),
      linkUrl: '/meet-chekup',
    },
  ];

  return (
    <Container
      maxWidth={false}
      sx={{
        maxWidth: '1440px',
        px: { xs: 2, md: 4 },
        mt: 10,
        mb: 10,
      }}
    >
      <Box sx={{ px: { xs: 5, md: 0 } }}>
        <Typo
          variant="h2"
          text={t('advantagesTitle')}
          sx={{
            textAlign: 'center',
            mb: 2,
          }}
        />

        <Typo
          variant="body1"
          text={t('advantagesSubtitle')}
          sx={{
            textAlign: 'center',
            maxWidth: '800px',
            mx: 'auto',
            mb: 7,
          }}
        />

        <Grid container spacing={3}>
          {items.map((item, index) => (
            <Grid item xs={12} md={3} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  borderRadius: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  background: 'rgba(255,255,255,0.9)',
                  backdropFilter: 'blur(5px)',
                  border: '1px solid #f0f0f0',
                }}
              >
                <Box
                  sx={{
                    width: 100,
                    height: 100,
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    background: 'rgba(188, 12, 12, 0.04)',
                    padding: '12px',
                  }}
                >
                  <Box
                    component="img"
                    src={item.icon}
                    alt={item.title}
                    sx={{
                      width: 'auto',
                      height: '125px',
                    }}
                  />
                </Box>
                <Typo
                  variant="h4"
                  text={item.title}
                  sx={{
                    color: '#212529',
                    mb: 2,
                  }}
                />
                <Typo
                  variant="body1"
                  text={item.description}
                  sx={{
                    color: '#6c757d',
                    mb: 3,
                    flexGrow: 1,
                  }}
                />

                {item.link && (
                  <Link
                    href={item.linkUrl || '#'}
                    sx={{
                      color: '#bc0c0c',
                      textDecoration: 'none',
                      '&:hover': {
                        textDecoration: 'underline',
                      },
                      mt: 'auto',
                      alignSelf: 'flex-start',
                      display: 'inline-flex',
                      alignItems: 'center',
                    }}
                  >
                    {item.link}
                  </Link>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Advantages;
